import { render, staticRenderFns } from "./MlFaq.vue?vue&type=template&id=0a55e416&scoped=true"
import script from "./MlFaq.vue?vue&type=script&lang=js"
export * from "./MlFaq.vue?vue&type=script&lang=js"
import style0 from "./MlFaq.vue?vue&type=style&index=0&id=0a55e416&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a55e416",
  null
  
)

export default component.exports